import React, { useState, useEffect } from "react";
import useStyles from "../styles";
import config from "../../../config";
import { useHistory } from "react-router-dom";

// components
import PageTitle from "../../../components/PageTitle/PageTitle";
import InputComponent from "../../partner/components/inputComponent";
import InputDecimal from "../../partner/components/inputDecimal";
import { CircularProgress, Switch } from "@material-ui/core";
import Modal from "../../modals/Modal";
import SnackbarMessage from "../../modals/SnackbarMessage";
import InputDisableSimpleText from "../../user/components/inputDisableSimpleText";
import { Edit, Delete } from "@material-ui/icons";

export default function InfoOtherConcept() {
    const expressions = {
        usuario: /^[a-zA-Z0-9_-]{4,16}$/, // Letras, numeros, guion y guion_bajo
        nombre: /^[a-zA-ZÀ-ÿ\s]{1,40}$/, // Letras y espacios, pueden llevar acentos.
        password: /^.{4,12}$/, // 4 a 12 digitos.
        email: /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
        numbers: /^[0-9]*$/, // 7 a 14 numeros.
        texto: /^[a-zA-Z0-9 ]{1,500}$/, // Letras
        textNumberAndSymbols: /^[a-zA-ZÀ-ÿ\sS&%'#+-@"!¡¿?()0-9._]+$/i
    }

    const classes = useStyles();
    let history = useHistory();

    const [baseUrl, setBaseUrl] = useState(config.config[0].baseUrl);
    const [name, setName] = useState({ text: '', valid: null });
    const [percent, setPercent] = useState(false);
    const [cost, setCost] = useState({ text: '', valid: null });
    const [creationDate, setCreationDate] = useState('');
    const [lastUpdateDate, setLastUpdateDate] = useState('');
    const [keyChange, setKeyChange] = useState(0);

    const [paymentConceptInfo, setPaymentConceptInfo] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingToSave, setIsLoadingToSave] = useState(false);
    const [disableInpunts, setDisableInpunts] = useState(true);
    const [showModal, setShowModal] = useState(false);
    const [showSnackbar, setShowSnackbar] = useState(false);
    const [messageSnackbar, setMessageSnackbar] = useState(false);
    const [errorSnackbar, setErrorSnackbar] = useState(false);

    const closeModalLogin = e => {
        setShowModal(false);
    }

    const handleToClose = (event, reason) => {
        if ("clickaway" == reason) return;
        setShowSnackbar(false);
    };

    const handleChange = event => {
        setPercent(event.target.checked);
    };

    const fetchPaymentConceptInfo = async () => {
        var id = localStorage.getItem('otherConceptInfo');

        await fetch(baseUrl + "otherConceptById/" + id,
            {
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
            })
            .then(response => response.json())
            .then(data => {
                if (data != null) {
                    setPaymentConceptInfo(data);
                    setName({ text: data.name, valid: 'true' });
                    setPercent(data.byPercent == 1 ? true : false);
                    setCost({ text: data.cost, valid: 'true' });
                    setCreationDate(data.creationDate);
                    setLastUpdateDate(data.lastUpdateDate);
                    setKeyChange(keyChange + 1);

                    setIsLoading(false);
                } else {
                    setShowModal(true);
                }

                setIsLoading(false);
            })
            .catch(error => null);
    }

    useEffect(() => {
        fetchPaymentConceptInfo();
    }, []);

    const onSubmit = async e => {
        e.preventDefault();
        setIsLoadingToSave(true);

        if (name.valid === 'true' && cost.valid === 'true') {
            const newPaymentConcept = {
                id: paymentConceptInfo.id, name: name.text, byPercent: percent ? 1 : 0, cost: cost.text
            };

            const response = await fetch(baseUrl + "updateOtherConcept", {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json', 'Content-Type': 'application/json',
                    'Authorization': localStorage.getItem("token")
                },
                body: JSON.stringify(newPaymentConcept)
            });
            const json = await response.json();
            if (json.message == "Ok") {
                setErrorSnackbar(false);
                setMessageSnackbar("Se guardó con éxito");
                setShowSnackbar(true);
            } else {
                if (json.message == "Access is denied") {
                    setShowModal(true);
                }
            }

            setDisableInpunts(!disableInpunts);
            setIsLoadingToSave(false);
        } else {
            setIsLoadingToSave(false);
        }
        fetchPaymentConceptInfo();
    }

    const onDelete = async e => {
        e.preventDefault();
        setIsLoadingToSave(true);

        const response = await fetch(baseUrl + "deleteOtherConcept/" + paymentConceptInfo.id, {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json', 'Content-Type': 'application/json',
                'Authorization': localStorage.getItem("token")
            },
        });

        const json = await response.json();
        if (json.message == "Ok") {
            localStorage.setItem('paymentConceptInfo', '');
            history.goBack();
        } else {
            if (json.message == "Access is denied") {
                setShowModal(true);
            }
        }
        setDisableInpunts(!disableInpunts);
        setIsLoadingToSave(false);
    }

    return (
        <div>
            {showModal ? (
                <Modal
                    isOpen={showModal}
                    closeModal={closeModalLogin}
                />
            ) : (
                <></>
            )}

            <SnackbarMessage
                showSnackbar={showSnackbar}
                messageSnackbar={messageSnackbar}
                handleToClose={handleToClose}
                isError={errorSnackbar}
            />

            <div className={classes.titleRow}>
                <PageTitle title="Configuración" />
                {isLoading ? (
                    <></>
                ) : (
                    <>
                        <div className={classes.marginAuto} />
                        <div className={classes.divActionButton} >
                            <Edit classes={{ root: classes.searchIcon }}
                                onClick={() => {
                                    setDisableInpunts(!disableInpunts);
                                }}
                            />
                        </div>
                        <div className={classes.divActionButtonDisable} >
                            <Delete
                                classes={{ root: !disableInpunts ? classes.activeButtonDisable : classes.searchIcon }}
                                onClick={!disableInpunts ? null : onDelete}
                            />
                        </div>
                    </>
                )}
            </div>

            <div className={classes.divAddPage} >
                <div className={classes.divTitle}>
                    <label className={classes.titleStyle}>Información de otro concepto</label>
                </div>

                {isLoading ? (
                    <CircularProgress size={26} className={classes.loginPage} />
                ) : (
                    <>
                        <div className={classes.divColumn} >
                            <InputComponent
                                text={name}
                                setPartnerCode={setName}
                                type="text"
                                label="Nombre"
                                name="name"
                                regularExpression={expressions.textNumberAndSymbols}
                                placeholder="Nombre"
                                isEnable={disableInpunts}
                            />

                            <div>
                                <label className={classes.label} >¿Es porcentaje?</label>
                                <div className={classes.divSwitch}>
                                    <p style={{ marginRight: "8px", fontSize: "16px", }}>No</p>
                                    <Switch
                                        checked={percent}
                                        onChange={handleChange}
                                        inputProps={{ "aria-label": "controlled" }}
                                        disabled={disableInpunts}
                                    />
                                    <p style={{ marginLeft: "8px", fontSize: "16px", }}>Si</p>
                                </div>
                            </div>

                            <div style={{ display: "flex", alignItems: "end" }}>
                                {percent ? (
                                    <></>
                                ) : (
                                    <text style={{ marginBottom: "8px" }}>$</text>
                                )}
                                <InputDecimal
                                    text={cost}
                                    setPartnerCode={setCost}
                                    type="text"
                                    label="Costo"
                                    name="price"
                                    placeholder="0.00"
                                    isEnable={disableInpunts}
                                />
                                {!percent ? (
                                    <></>
                                ) : (
                                    <text style={{ marginBottom: "8px" }}>%</text>
                                )}
                            </div>

                            <InputDisableSimpleText
                                value={creationDate}
                                type="text"
                                label="Fecha de alta"
                                name="creationDate"
                                placeholder="Fecha"
                                isPrice={false}
                            />

                            <InputDisableSimpleText
                                value={lastUpdateDate}
                                type="text"
                                label="Última modificación"
                                name="lastUpdateDate"
                                placeholder="Fecha"
                                isPrice={false}
                            />
                        </div>
                    </>)}

                {disableInpunts ? (
                    <br />
                ) : (
                    <div className={classes.divButton}>
                        {isLoadingToSave ? (
                            <div className={classes.loginLoader} >
                                <CircularProgress size={26} />
                            </div>
                        ) : (
                            <button
                                className={classes.enableButton}
                                onClick={onSubmit}
                            >Guardar</button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}
